import { animate, state, style, transition, trigger } from "@angular/animations";

export const dropdownAnimation = trigger('dropdownAnimation',[
        transition(':enter',[
            style({
                opacity:0,
                transform:'translateY(-8px) scale(0.98)'
            }),
            animate(
                '460ms cubic-bezier(0.16, 1, 0.3, 1)',
                style({
                    opacity: 1,
                    transform: 'translateY(0) scale(1)',
                })
            ),
        ]),
        transition(':leave', [
            animate(
                '120ms cubic-bezier(0.4, 0, 1, 1)',
                style({ opacity: 0, transform: 'translateY(-6px) scale(0.98)' })
            ),
        ]),
    ]

)

export const bottomSheetAnimation = trigger('bottomSheetAnimation', [
    transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
        animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY(100%)' }))
    ])
]);


export const accordionAnimation = trigger('accordionAnimation', [
    state('void', style({ height: '0', opacity: 0, padding: '0' })),
    state('*', style({ height: '*', opacity: 1, padding: '*' })),
    transition('void <=> *', [animate('300ms cubic-bezier(0.4,0,0.2,1)')]),
]);

export const slideUpDownAnimation = trigger('slideUpDown', [
  transition(':enter', [
    style({ transform: 'translateY(0%)', opacity: 0 }),
    animate('500ms ease-in-out', style({ transform: 'translateY(100%)', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('300ms ease-in', style({ transform: 'translateY(0%)', opacity: 0 }))
  ])
]);

export const rightDrawerAnimation = trigger('rightDrawer', [
  state('open', style({ transform: 'translateX(0%)', opacity: 1 })),
  state('closed', style({ transform: 'translateX(100%)', opacity: 0 })),
  transition('closed => open', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('300ms ease-out')
  ]),
  transition('open => closed', [
    animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
  ]),
])
